import { render } from "./SingleCourse.vue?vue&type=template&id=cf77b7bc"
import script from "./SingleCourse.vue?vue&type=script&lang=js"
export * from "./SingleCourse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__